module.exports = __webpack_public_path__ + "static/media/heatBlock.e8603590.svg";